export default "__VITE_ASSET__lZkkMgMG__"